import {
  BdsButton,
  BdsGrid,
  BdsIllustration,
  BdsInput,
  BdsModal,
  BdsModalAction,
  BdsTypo,
} from 'blip-ds/dist/blip-ds-react/components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal as ModalProps } from '../../interfaces';
import './Modal.scss';

export const Modal = ({
  buttonAction,
  button_text,
  closeModal,
  input_example,
  input_label,
  open,
  max_length,
  title,
  subtitle,
  loading,
}: ModalProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const inputRef = React.useRef<HTMLBdsInputElement | null>(null);

  useEffect(() => {
    if (!open) {
      return;
    }
    setTimeout(() => {
      inputRef.current?.getInputElement().then(inputElement => {
        inputElement?.focus();
      });
    }, 10);
  }, [open]);

  useEffect(() => {
    if (open) {
      return;
    }
    setInputValue('');
    setErrorMessage('');
  }, [open]);

  useEffect(() => {
    const modal = document.getElementById('modal');
    modal!.addEventListener('bdsModalChanged', () => {
      closeModal();
    });
  });

  const handleSubmit = () => {
    if (inputValue.trim()) {
      setErrorMessage('');
      buttonAction(capitalizeFirstLetter(inputValue));
    } else {
      setErrorMessage(t('go-personal-modal-error-empty'));
    }
  };

  const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <BdsModal open={open} size="fixed" id="modal">
      <BdsGrid gap="4" alignItems="center">
        <BdsIllustration class="modal_illustration" name="speak-bubble" type="spots" />
        <BdsGrid direction="column" gap="none">
          <BdsTypo bold="bold" variant="fs-20" class="modal_title">
            {title}
          </BdsTypo>
          {subtitle && (
            <BdsTypo variant="fs-14" bold="regular" style={{ marginBottom: '16px' }}>
              {subtitle}
            </BdsTypo>
          )}
          <BdsInput
            autoCapitalize="on"
            class="input"
            label={input_label}
            onBdsChange={e => setInputValue(e.detail.value)}
            placeholder={input_example}
            danger={Boolean(errorMessage)}
            errorMessage={errorMessage}
            value={inputValue}
            maxlength={max_length}
            ref={inputRef}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmit();
              }
            }}
          />
        </BdsGrid>
      </BdsGrid>
      <BdsModalAction>
        <BdsGrid gap="2" justifyContent="flex-end" xxs="12">
          <BdsButton variant="secondary" onClick={() => !loading && closeModal()} disabled={loading}>
            {t('go-personal-modal-cancel')}
          </BdsButton>
          <BdsButton onClick={() => handleSubmit()} bdsLoading={loading}>
            {button_text}
          </BdsButton>
        </BdsGrid>
      </BdsModalAction>
    </BdsModal>
  );
};
